import { Link } from 'react-router-dom';

const articles = [
  {
    slug: 'allchinabuy-spreadsheet-complete-guide',
    title: 'The Complete AllChinaBuy Spreadsheet Guide for Beginners & Experts',
    excerpt: 'Everything you need to know about using an AllChinaBuy spreadsheet — from getting started to advanced shopping strategies, safety tips, and category breakdowns.',
    readTime: '8 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20laptop%20on%20wooden%20desk%20showing%20organized%20spreadsheet%20with%20product%20listings%2C%20warm%20morning%20light%20through%20window%2C%20productive%20workspace%20with%20notebook%20and%20coffee%2C%20modern%20minimalist%20home%20office%2C%20clean%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20focused%20and%20organized%20atmosphere&width=600&height=400&seq=article-card-v2-01-z50&orientation=landscape',
  },
  {
    slug: 'how-to-find-best-sneakers-allchinabuy-spreadsheet',
    title: 'How to Find the Best Sneakers Using the AllChinaBuy Spreadsheet',
    excerpt: 'Discover top sneaker finds, compare sellers, and spot the best deals using our daily-updated spreadsheet with verified QC notes and price tracking.',
    readTime: '6 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Pair%20of%20trendy%20white%20sneakers%20on%20minimal%20cream%20surface%20with%20product%20tags%20and%20inspection%20notes%20beside%20them%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20clean%20composition%20with%20warm%20neutral%20tones%2C%20lifestyle%20shopping%20concept&width=600&height=400&seq=article-card-v2-02-z51&orientation=landscape',
  },
  {
    slug: 'allchinabuy-spreadsheet-safety-tips',
    title: 'AllChinaBuy Spreadsheet Safety Tips: Shop Smart & Avoid Scams',
    excerpt: 'Learn essential safety practices for shopping through spreadsheet links, including seller verification, QC photo review, and shipping protection strategies.',
    readTime: '7 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Padlock%20symbol%20and%20shield%20icon%20next%20to%20shopping%20bags%20on%20warm%20beige%20surface%2C%20online%20shopping%20safety%20concept%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20composition%2C%20reassuring%20and%20trustworthy%20aesthetic%2C%20editorial%20still%20life%20photography%20with%20warm%20neutral%20palette&width=600&height=400&seq=article-card-v2-03-z52&orientation=landscape',
  },
  {
    slug: 'top-designer-brands-allchinabuy-spreadsheet',
    title: 'Top Designer Brands You Can Find in the AllChinaBuy Spreadsheet',
    excerpt: 'Browse the most popular designer and streetwear brands available through verified spreadsheet listings, complete with seller ratings and price comparisons.',
    readTime: '5 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20brand%20logos%20and%20premium%20fashion%20items%20elegantly%20arranged%20on%20white%20marble%20surface%2C%20luxury%20editorial%20photography%2C%20soft%20golden%20lighting%2C%20sophisticated%20composition%20with%20subtle%20reflections%2C%20high-end%20fashion%20aesthetic%2C%20warm%20champagne%20and%20cream%20tones&width=600&height=400&seq=article-card-v2-04-z53&orientation=landscape',
  },
  {
    slug: 'allchinabuy-spreadsheet-shipping-guide',
    title: 'AllChinaBuy Spreadsheet Shipping Guide: Methods, Costs & Delivery Times',
    excerpt: 'A complete breakdown of shipping methods linked in the spreadsheet, including estimated delivery times, costs, and which carriers are most reliable for your country.',
    readTime: '6 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20and%20packaging%20materials%20on%20wooden%20table%20with%20world%20map%20in%20background%2C%20warm%20natural%20light%2C%20global%20shipping%20and%20logistics%20concept%2C%20clean%20editorial%20photography%2C%20organized%20and%20professional%20aesthetic%2C%20soft%20neutral%20tones%20with%20gentle%20shadows&width=600&height=400&seq=article-card-v2-05-z54&orientation=landscape',
  },
  {
    slug: 'beginner-first-purchase-allchinabuy-spreadsheet',
    title: 'Your First Purchase: A Beginners Guide to the AllChinaBuy Spreadsheet',
    excerpt: 'Never used a shopping spreadsheet before? This step-by-step walkthrough guides beginners through their first AllChinaBuy purchase with confidence.',
    readTime: '7 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20pointing%20at%20laptop%20screen%20with%20shopping%20website%20open%2C%20beginner%20learning%20concept%2C%20warm%20afternoon%20light%2C%20cozy%20home%20office%20setting%2C%20editorial%20lifestyle%20photography%2C%20encouraging%20and%20friendly%20atmosphere%2C%20soft%20natural%20tones%2C%20clean%20modern%20environment&width=600&height=400&seq=article-card-v2-06-z55&orientation=landscape',
  },
  {
    slug: 'qc-photos-guide-allchinabuy-spreadsheet',
    title: 'QC Photos Guide: How to Verify Products Using the AllChinaBuy Spreadsheet',
    excerpt: 'Master the art of quality control photo review. Learn what to look for in QC images, common red flags, and how to request better photos from sellers.',
    readTime: '5 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20detailed%20product%20inspection%20photos%20on%20clean%20white%20surface%2C%20quality%20control%20concept%2C%20bright%20natural%20daylight%2C%20professional%20inspection%20aesthetic%2C%20clean%20editorial%20photography%2C%20sharp%20focus%20on%20details%2C%20organized%20and%20methodical%20composition&width=600&height=400&seq=article-card-v2-07-z56&orientation=landscape',
  },
  {
    slug: 'seasonal-trending-finds-allchinabuy-spreadsheet',
    title: 'Seasonal Trending Finds: What is Hot in the AllChinaBuy Spreadsheet Right Now',
    excerpt: 'Stay ahead of fashion trends with our curated seasonal picks from the spreadsheet. Discover what everyone is searching for this season.',
    readTime: '4 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trending%20fashion%20items%20including%20colorful%20accessories%20and%20seasonal%20pieces%20displayed%20on%20warm%20terracotta%20surface%2C%20golden%20hour%20lighting%2C%20editorial%20fashion%20photography%2C%20vibrant%20yet%20harmonious%20color%20palette%2C%20aspirational%20lifestyle%20aesthetic%20with%20soft%20shadows&width=600&height=400&seq=article-card-v2-08-z57&orientation=landscape',
  },
  {
    slug: 'spreadsheet-vs-manual-browsing-allchinabuy',
    title: 'AllChinaBuy Spreadsheet vs Manual Browsing: Which Is Better for You?',
    excerpt: 'We compare organized spreadsheet shopping against manual platform browsing across speed, accuracy, price discovery, and overall shopping experience.',
    readTime: '6 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20with%20organized%20spreadsheet%20on%20left%20and%20cluttered%20browser%20tabs%20on%20right%2C%20modern%20workspace%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20composition%2C%20decision%20making%20visual%20metaphor%2C%20warm%20neutral%20background%2C%20professional%20aesthetic&width=600&height=400&seq=article-card-v2-09-z58&orientation=landscape',
  },
];

export default function ArticlesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-4">
            Shopping Guides & Tips
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Expert AllChinaBuy Spreadsheet Guides
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            In-depth articles to help you shop smarter, safer, and save money with the <strong>AllChinaBuy spreadsheet</strong>.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="h-44 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={`AllChinaBuy Spreadsheet - ${article.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 mt-4 text-xs text-primary-600 font-medium">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}